// Keyed by quizId: a retake creates a new quiz row, so it gets its own email, while a
// page refresh or back-navigation on the same quiz does not send a duplicate.
export const RESULTS_EMAILED_KEY = "mpay_resultsEmailedQuizIds";

export function claimResultsEmail(
  quizId: number,
  storage: Storage = localStorage
): boolean {
  let sent: number[] = [];
  try {
    const parsed = JSON.parse(storage.getItem(RESULTS_EMAILED_KEY) || "[]");
    if (Array.isArray(parsed)) sent = parsed;
  } catch {
    sent = [];
  }
  if (sent.includes(quizId)) return false;
  storage.setItem(RESULTS_EMAILED_KEY, JSON.stringify([...sent, quizId].slice(-50)));
  return true;
}

export function releaseResultsEmail(quizId: number, storage: Storage = localStorage): void {
  try {
    const parsed = JSON.parse(storage.getItem(RESULTS_EMAILED_KEY) || "[]");
    if (Array.isArray(parsed)) {
      storage.setItem(RESULTS_EMAILED_KEY, JSON.stringify(parsed.filter((id) => id !== quizId)));
    }
  } catch {
    // nothing to release
  }
}
